
import React, { useState } from 'react';
import BuscarCliente from '../componentes/gestion-clientes/BuscarCliente';
import ListaClientes from '../componentes/gestion-clientes/ListaClientes';
import ModalCrearCliente from '../componentes/ModalCrearCliente'; // Importar el nuevo modal

const GestionClientesPage = () => {
    // Estado para controlar qué vista se muestra: 'buscar', 'lista'
    const [vistaActual, setVistaActual] = useState('buscar');
    // Estado para controlar la visibilidad del modal de crear cliente
    const [isModalCrearClienteOpen, setIsModalCrearClienteOpen] = useState(false);

    // Función para renderizar el componente correcto según el estado
    const renderizarVista = () => {
        switch (vistaActual) {
            case 'lista':
                return <ListaClientes onNuevoCliente={() => setIsModalCrearClienteOpen(true)} />; // Abre el modal desde ListaClientes si es necesario
            case 'buscar':
            default:
                return <BuscarCliente />;
        }
    };

    // Botones de navegación para facilitar el cambio entre vistas
    const BotonesNavegacion = () => (
        <div className="mb-4 flex justify-center gap-2">
            <button 
                onClick={() => setVistaActual('buscar')} 
                className={`px-4 py-2 text-sm font-semibold rounded-md transition-colors ${vistaActual === 'buscar' ? 'bg-[#ee6e3b] text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            >
                Buscar
            </button>
            <button 
                onClick={() => setIsModalCrearClienteOpen(true)} // Abre el modal al hacer clic en "Nuevo"
                className={`px-4 py-2 text-sm font-semibold rounded-md transition-colors bg-[#ee6e3b] text-white`} // Siempre resaltado o con estilo de acción
            >
                Nuevo
            </button>
            <button 
                onClick={() => setVistaActual('lista')} 
                className={`px-4 py-2 text-sm font-semibold rounded-md transition-colors ${vistaActual === 'lista' ? 'bg-[#ee6e3b] text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            >
                Lista
            </button>
        </div>
    );

    return (
        <div className="bg-white font-sans min-h-screen">
            <main className="p-5 max-w-7xl mx-auto">
                <BotonesNavegacion />
                {renderizarVista()}
            </main>
            {/* Renderizar el ModalCrearCliente */}
            <ModalCrearCliente 
                isOpen={isModalCrearClienteOpen} 
                onClose={() => setIsModalCrearClienteOpen(false)} 
                onClienteCreado={() => { 
                    // Lógica para refrescar la lista de clientes o mostrar un mensaje de éxito
                    setIsModalCrearClienteOpen(false); // Cerrar el modal después de crear
                    setVistaActual('lista'); // Opcional: ir a la lista después de crear
                }} 
            />
        </div>
    );
};

export default GestionClientesPage;
